import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { DynamicDataItem } from 'utility/types';

interface SummaryStatisticsDataTableProps {
    data: DynamicDataItem<number | string>[];
}

const SummaryStatisticsDataTable = ({ data }: SummaryStatisticsDataTableProps) => {
    const headers = data.length > 0 ? Object.keys(data[0]) : [];
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {headers?.map((header) => (
                            <TableCell key={header} 
                            sx={{
                                fontWeight: 700,
                                backgroundColor: 'rgba(224, 224, 224, 1)',
                                textTransform: 'capitalize',
                            }}>{header}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((row, index) => (
                        <TableRow key={index}>
                            {Object.values(row)?.map((value, i) => (
                                <TableCell key={i}>{value}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SummaryStatisticsDataTable;
